import * as React from "react";
const SvgBackArrow = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="#333" d="M16 7H3.83l5.585-5.585L8 0 0 8l8 8 1.415-1.415L3.83 9H16z" /></svg>;
export default SvgBackArrow;